import "./EditableExperience.css"
import { useState } from "react";
import Popup from "reactjs-popup";
import EditIcon from '@mui/icons-material/Edit';
import UpdatePastExp from "./package/UpdatePastExp";
import CreateNewExperience from "./package/CreateNewExperience";
import DeleteExperience from "./package/DeleteExperience";

const EditableExperience = ({ id, title, pname, feedback, paddress, isActionCreate }) => {
    const [name, setName] = useState(pname ?? "");
    const [address, setAddress] = useState(paddress ?? "");
    const [description, setDescription] = useState(feedback ?? "");
    const [profilePic, setProfilePic] = useState(null);
    const [btnLoading, setBtnLoading] = useState(false);
    const [deleteBtnLoading, setDeleteBtnLoading] = useState(false);

    function refreshPage() {
        window.location.reload();
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isActionCreate) {
            let success = await CreateNewExperience({
                id,
                name,
                address: address,
                feedback: description,
                profilePic: profilePic,
                btnLoading: btnLoading,
                setBtnLoading: setBtnLoading,
            });
            if (success) {
                refreshPage();
            }
        } else {
            let success = await UpdatePastExp({
                id: id,
                name: name,
                feedback: description,
                address: address,
                btnLoading: btnLoading,
                setBtnLoading: setBtnLoading,
                profilePic: profilePic,
            });
            if (success) {
                refreshPage();
            }
        }
    };

    const handleDeleteProfile = async (e) => {
        e.preventDefault();
        let success = await DeleteExperience({
            btnLoading: deleteBtnLoading,
            setBtnLoading: setDeleteBtnLoading,
            id: id ?? "",
        });
        if (success) {
            refreshPage();
        }
    };

    return (
        <Popup
            trigger={
                <div className="dt_trigger_btn">
                    {title ?
                        <div style={{ fontSize: "1.2rem", margin: "1rem 0" }}
                            className="primary_btn">
                            {title}
                        </div> :
                        <div className="dt_edit_btn" style={{ marginRight: "0.5rem" }} >
                            <EditIcon />
                        </div>
                    }
                </div>
            }
            modal
        >
            {(close) => {
                return (
                    <div className="ehp_edit_popup" >
                        <div className="ehp_inner_container"
                            style={{
                                height: "80vh"
                            }} >
                            <form className="ehp_form_container" onSubmit={handleSubmit}>
                                <h1 className="ehp_form_container_header"  >
                                    {title ?? "Edit Speaker"}
                                </h1>
                                <div className="ehp_form_top">
                                    <div className="ehp_form_left">
                                        <label htmlFor="name" className="ehp_label">
                                            Name:
                                        </label>
                                        <input
                                            id="name"
                                            value={name}
                                            type="text"
                                            onChange={(e) => {
                                                setName(e.target.value);
                                            }}
                                            className="ehp_input_field"
                                            placeholder=""
                                            required
                                        />
                                        <label htmlFor="address" className="ehp_label">
                                            Address:
                                        </label>
                                        <input
                                            id="address"
                                            value={address}
                                            type="text"
                                            onChange={(e) => {
                                                setAddress(e.target.value);
                                            }}
                                            className="ehp_input_field"
                                            placeholder=""
                                            required
                                        />
                                        <label htmlFor="position" className="ehp_label">
                                            Feedback:
                                        </label>
                                        <input
                                            id="position"
                                            value={description}
                                            type="text"
                                            onChange={(e) => {
                                                setDescription(e.target.value);
                                            }}
                                            className="ehp_input_field"
                                            placeholder=""
                                            required
                                        />
                                        <label htmlFor="profilePic" className="ehp_label">
                                            New Profile Picture:
                                        </label>
                                        {
                                            isActionCreate ?
                                                <input type="file" name="file" id="profilePic"
                                                    accept="image/*"
                                                    required
                                                    className="ehp_file_input dt_pp_input"
                                                    onChange={(event) => {
                                                        setProfilePic(event.target.files[0]);
                                                    }}
                                                /> :
                                                <input type="file" name="file" id="profilePic"
                                                    accept="image/*"
                                                    className="ehp_file_input dt_pp_input"
                                                    onChange={(event) => {
                                                        setProfilePic(event.target.files[0]);
                                                    }}
                                                />
                                        }

                                    </div>
                                </div>
                                <div className="ehp_form_bottom">
                                    <input
                                        type="submit"
                                        className="ehp_submit primary_btn"
                                        value={btnLoading ? "Loading..." : "Submit"}
                                    />
                                    {
                                        isActionCreate ? "" :
                                            <input
                                                type="button"
                                                onClick={handleDeleteProfile}
                                                className="ehp_cancel primary_btn"
                                                value={deleteBtnLoading ? "Loading..." : "Delete"}
                                            />
                                    }
                                    <input
                                        type="button"
                                        className="ehp_cancel primary_btn "
                                        onClick={() => {
                                            close();
                                        }}
                                        value={"Cancel"}
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                );
            }}
        </Popup>
    );
};

export default EditableExperience;